import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FaqSchemaModule } from './faq/faq-schema.module';

@NgModule({
  imports: [CommonModule],
  exports: [FaqSchemaModule],
})
export class StructuredDataModule {}
